import { ClientType } from 'model/client.model';
import zeplinColor from 'theme/Color';

export type ClientHealthStatus = 'Strong' | 'Good' | 'Need Attention';

const toNumber = (value?: string | number | null) => {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getClientHealthScore = (client: ClientType) => {
  if (typeof client?.healthScore === 'number' && Number.isFinite(client?.healthScore)) {
    return Math.max(0, Math.min(100, Math.round(client?.healthScore)));
  }

  const openDeals = toNumber(client?.openDealAmount);
  const closedDeals = toNumber(client?.closedDealAmount);
  const totalDeals = openDeals + closedDeals;

  if (totalDeals <= 0) return 0;

  return Math.max(0, Math.min(100, Math.round((closedDeals / totalDeals) * 100)));
};

export const getClientStatusLabel = (client: ClientType): ClientHealthStatus => {
  const rawStatus = client.status?.trim().toLowerCase();

  if (rawStatus === 'strong') return 'Strong';
  if (rawStatus === 'good') return 'Good';
  if (rawStatus === 'need attention' || rawStatus === 'need_attention') return 'Need Attention';

  const score = getClientHealthScore(client);
  if (score >= 70) return 'Strong';
  if (score >= 10) return 'Good';
  return 'Need Attention';
};

export const getHealthBarColor = (score: number) => {
  if (score >= 70) return zeplinColor.Success;
  if (score >= 10) return zeplinColor.AlertInfo;
  return zeplinColor.Error;
};

export const getStatusChipColor = (status: ClientHealthStatus) => {
  if (status === 'Strong') return zeplinColor.Success;
  if (status === 'Good') return zeplinColor.AlertInfo;
  return zeplinColor.Error;
};
